import Uri from 'jsuri';

import type { NaptimeResourceType } from 'bundles/naptimejs/resources/NaptimeResource';

import type { NaptimeClientDataProcessor, NaptimeClientQuery } from './NaptimeClient';
import NaptimeClient from './NaptimeClient';

class LocalMultiGet<Result, Resource extends NaptimeResourceType> extends NaptimeClient<Result, Resource> {
  declare ids: Array<string | number>;

  constructor(
    resource: Resource,
    ids: Array<string | number>,
    params?: NaptimeClientQuery,
    dataProcessor?: NaptimeClientDataProcessor<Result, Resource[]>
  ) {
    super(resource, Object.assign({ ids }, params), dataProcessor);
    this.ids = ids;
  }

  getBaseUri() {
    const uri = new Uri(`/api/${this.resourceName}`);
    uri.addQueryParam('ids', this.ids.join(','));
    return uri;
  }

  isValid() {
    return this.ids !== undefined;
  }

  getClientIdentifier() {
    return `LocalGet:${this.ids.join(',')}|${super.getClientIdentifier()}`;
  }
}

export default LocalMultiGet;
